<template>
  <div>
    <dashboard-page-title :showAddBtn="false" :showFilter="true" :showSearch="true" :showExportation="true">الشركات</dashboard-page-title>

    <main-table :fields="fields" :baseURL="VUE_APP_TRANSPORTATION_LINK"  :status-url="'companies/status'" :list_url="'companies'"></main-table>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { VUE_APP_TRANSPORTATION_LINK } from '@/config/constant'
export default {
  name: 'offCompanies',
  mounted () {
    core.index()
  },
  data () {
    return {
      VUE_APP_TRANSPORTATION_LINK,
      fields: [
        { label: 'شعار الشركة', key: 'logo', type: 'image', class: 'text-right' },
        { label: 'اسم الشركة', key: 'name', type: 'name', class: 'text-right' },
        { label: 'عدد السائقين', key: 'name', class: 'text-right' },
        { label: 'عدد الشاحنات', key: 'numberOfVehicles', type: 'text', class: 'text-right' },
        { label: 'عدد الرحلات', key: 'numberOfTrips', type: 'text', class: 'text-right' },
        { label: ' اجمالى الأرباح', key: 'profits', class: 'text-right' },
        {
          label: 'الحالة', key: 'change_status'
        }
      ]
    }
  },
  methods: {
    addMerchant () {
      console.log('hello')
    }
  }
}
</script>
